/**
 * "Cập nhật tới hôm nay" / "Trễ 1 ngày" / "Mất nguồn N ngày" — always on screen
 * (docs/07-gui-proposal §2). The verdict is a pure function; this only paints it.
 */
import { useQuery } from '@tanstack/react-query';

import { useToday } from '../hooks/usePeriod.js';
import { fetchOverview, type Overview, overviewKey } from '../services/statsApi.js';
import { coverageText, freshnessState } from '../utils/freshness.js';

const TONE_COLOUR = {
  ok: 'var(--positive)',
  late: 'var(--warning)',
  lost: 'var(--critical)',
  unknown: 'var(--ink-faint)',
} as const;

export function FreshnessBadge() {
  const today = useToday();
  const overview = useQuery<Overview>({
    queryKey: overviewKey(today, today),
    queryFn: () => fetchOverview(today, today),
    staleTime: 5 * 60_000,
  });

  const freshness = overview.data?.freshness ?? null;
  if (overview.isLoading) return null;
  const state = freshnessState(freshness, today);
  const coverage = coverageText(freshness);

  return (
    <span
      className="fresh"
      style={{ '--tone': TONE_COLOUR[state.tone] } as React.CSSProperties}
      title={coverage ?? 'Chưa có lượt cào nào'}
    >
      {state.text}
    </span>
  );
}
